import { defineBlock, EditableText } from "eddev/blocks"
import { Col, Grid } from "@components/layout/Grid"
import { ChartContainer } from "@components/atoms/data/Components"

export const meta: BlockMeta = {
  title: "Road Safety Chart Intro Text",
  category: "common",
  icon: "editor-paragraph",
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    templates: ["templates/road-safety"],
  },
}

export default defineBlock("data/road-safety-chart-container", (props) => {
  return (
    <ChartContainer>
      <div className="grid-auto px-4 md:px-6 xxl:px-0 !w-[100vw] xl:!max-w-[1600px] xxl:!max-w-[1720px]">
        <div className="col-span-12 md:col-span-10 lg:col-span-6">
          <EditableText as="p" store="content" placeholder="Enter content" />
        </div>
      </div>
    </ChartContainer>
  )
})
